import { apiClient } from "@/api/axios";
import type { ApiResponse } from "@/types/api";

import type { InventoryRequest, InventoryData } from "@/types/inventory";

export async function GetInventory(payload: InventoryRequest) {
  const { data } = await apiClient.post<ApiResponse<InventoryData>>(
    "/api/AgentTicketInventory/dashboard",
    payload,
  );
  
  if (!data.status) {
    throw new Error(data.message ?? "Inventory fetch failed");
  }

  return data;
}